import { useQuery } from 'react-query'
import { getPacienteById } from '../../../paciente-management/pacientes-list/core/_requests'

/**
 * Alergias registradas do paciente. Não vêm no atendimento: saem do cadastro (`GET /pacientes/{id}`,
 * que só as devolve para médico). Falha aqui não bloqueia a prescrição: a lista fica vazia.
 */
export const useAlergiasPaciente = (pacienteId?: number) => {
  const { data } = useQuery(
    ['prescricao-alergias', pacienteId],
    () => getPacienteById(pacienteId as number),
    {
      enabled: !!pacienteId,
      staleTime: 5 * 60_000,
      refetchOnWindowFocus: false,
      retry: false,
      select: (paciente) =>
        (paciente.alergias ?? [])
          .map((alergia) => alergia.descricao?.trim() ?? '')
          .filter((descricao) => descricao.length > 0),
    }
  )
  return data ?? []
}

const normalizar = (texto: string) => texto.normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase()

/**
 * Alergia cujo texto coincide com o nome do item. É só coincidência de texto: o cadastro de
 * alergia é livre e não aponta para o princípio ativo.
 */
export const alergiaCoincidente = (nomeItem: string, alergias: string[]) => {
  const nome = normalizar(nomeItem)
  return alergias.find((alergia) => {
    const termo = normalizar(alergia)
    return termo.length >= 3 && (nome.includes(termo) || termo.includes(nome))
  })
}
